import { ChequeStatusReportCsvData } from '../../../types/chequeStatusType';
import { downloadCsvFromJson } from '../../../utils/fileGeneration';
import { SnackbarSeverityType } from '../../../enums';
import chequeStatusReportApis from '../../../apis/payments/chequeStatusReport';

const downloadFailedChequeStatusRecords = (
  failedRecords: ChequeStatusReportCsvData[]
): number => {
  if (!failedRecords.length) return 0;

  const headersSet = new Set<string>();
  failedRecords.forEach((record: any) =>
    Object.keys(record || {}).forEach((key) => headersSet.add(key))
  );
  const headers = Array.from(headersSet);
  const body = failedRecords.map((row: any) =>
    headers.map((header) => row[header] as any)
  );

  downloadCsvFromJson('unsuccessful-cheque-status-records', 'FailedRecords', {
    headers,
    body
  });
  return failedRecords.length;
};

const processChequeStatusUpload = async (
  file: File,
  onProgress: (percent: number) => void,
  showToast: (message: string, severity: SnackbarSeverityType) => void
) => {
  const result = await chequeStatusReportApis.uploadChequeStatusReport(
    file,
    onProgress
  );
  const failedRecords = result?.unSuccessfulRecords || [];
  if (failedRecords.length) {
    const processed = downloadFailedChequeStatusRecords(failedRecords as any);
    showToast(
      `A csv file with unsuccessful record(s) downloaded.`,
      SnackbarSeverityType.error
    );
    return { failedCount: processed, success: false };
  }
  showToast(
    'Cheque Statuses updated successfully.',
    SnackbarSeverityType.success
  );
  return { failedCount: 0, success: true };
};

export { downloadFailedChequeStatusRecords, processChequeStatusUpload };
